/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
// import { CTAHorizontal } from './horizontal'
// import { CTAVertical } from './vertical'

// TODO: rationalize these being DNV specific styled components
//       used inside of a standard simplicity component
// ------------- Override components ------------------
import { HighlightHorizontal } from "./highlight-dnv-styled/horizontal-inside";
import { HighlightVertical } from "./highlight-dnv-styled/vertical";

const CallToActionComponent = (props) => {
    const component = props?.component;
    const image = component?.image ?? "";
    const title = component?.title ?? "";
    const description = component?.description ?? "";
    const imageCard = component?.imageCard;
    const links = component?.links ?? [];
    const settings = component?.settings ?? {};

    const style = settings?.style;
    const format = settings?.format;

    // const hasContent = isValidGuid(image)
    const isVertical = imageCard === "vertical";
    const isHorizontal = imageCard === "horizontal";

    return (
        <>
            {isVertical && (
                <HighlightVertical
                    image={image}
                    title={title}
                    description={description}
                    links={links}
                    style={style}
                    format={format}
                    settings={settings}
                />
            )}

            {isHorizontal && (
                <HighlightHorizontal
                    image={image}
                    title={title}
                    description={description}
                    links={links}
                    style={style}
                    format={format}
                    settings={settings}
                />
            )}
        </>
    );
};

CallToActionComponent.displayname = "CallToActionComponent";
export { CallToActionComponent };
